//币种
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import icon404 from "assets/images/common/icon404.png";

export default observer(({ data, isOnlyLogo, className }) => {
  const t = useTranslation();
  const { finance, fund } = useStore();

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    const currency = data.toLowerCase();
    const currencyObj = fund.currencyMap[currency];
    if (!currencyObj) return { label: currency.toUpperCase() };
    return {
      logo: currencyObj.logo,
      label: currency.toUpperCase(),
    };
  }, [data, fund.currencyMap]);

  if (isOnlyLogo) return <img src={selfData.logo || icon404} className={className} />;

  return (
    <div className={cx(styles.main, className)}>
      <img src={selfData.logo || icon404} />
      <span>{selfData.label}</span>
    </div>
  );
});
